import MaterialCardContent, {
    CardContentProps,
} from '@mui/material/CardContent';

export function CardContent(props: CardContentProps) {
    return (
        <MaterialCardContent data-testid={'CardContent-container'} {...props} />
    );
}

export default CardContent;
